import axios from 'axios'
import store from '../store/index'

const API_URL = process.env.VUE_APP_API_URL + '/users/'
class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'auth', {
        email: user.email,
        password: user.password
      })
      .then(async response => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data))
          this.configureAxios()
          this.me()
        }
        return response.data
      })
  }
  logout() {
    localStorage.removeItem('user')
    this.configureAxios()
  }
  register(user) {
    return axios
      .post(API_URL + 'register', {
        email: user.email,
        password: user.password,
        name: user.name,
        lastName: user.lastName,
        phone: user.phone,
      })
      .then(async response => {
        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data))
          this.configureAxios()
          this.me()
        }
        return response.data
      })
  }
  isAuthenticated() {
    let user = JSON.parse(localStorage.getItem('user'))
    return !!(user && user.token)
  }
  me() {
    return axios
      .get(API_URL + 'me')
      .then(response => {
        store.commit('user/set', response.data)
        return response.data
      })
  }
  edit(user) {
    return axios
      .put(API_URL + 'me', {
        name: user.name,
        lastName: user.lastName,
        phone: user.phone,
      })
      .then(async response => {
        store.commit('user/set', response.data)
        return response.data
      })
  }
  // DEPRECATED
  // TODO: remove
  configureAxios() {
    if (this.isAuthenticated()) {
      // Set token for the following requests with Axios
      axios.defaults.headers.common['authorization'] = `Bearer ${JSON.parse(localStorage.getItem('user')).token}`
    } else {
      // Remove token for the following requests with Axios
      axios.defaults.headers.common['authorization'] = null
    }
  }
}
export default new AuthService()